module.exports = __webpack_public_path__ + "static/media/AU.ecef4318.svg";